// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2QKQ3","row":"ProcedureTreatmentSummary_row__10nSN"};